import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KhoXuatKho, KhoXuatKhoChiTiet } from '../kho-xuat-kho-page-model/kho-xuat-kho-page.model';
const API_ROOT_URL = environment.ApiRoot + '/phieuxuatkho';

@Injectable()
export class KhoXuatKhoPageService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'desc', 'NGAYLAP', 0, 10));
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'desc', 'NGAYLAP', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	lastData$: BehaviorSubject<KhoXuatKho[]> = new BehaviorSubject([]);
	dataNew$: BehaviorSubject<number[]> = new BehaviorSubject([]);
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DanhSachPhieuXuatKho', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	insertOrder(item: KhoXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/TaoPhieuXuatKho', item, { headers: httpHeaders });
	}

	editOrder(item: KhoXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhoXuatKho>(API_ROOT_URL+'/CapNhatPhieuXuatKho', item, { headers: httpHeaders });
	}

	detailOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoXuatKho>(API_ROOT_URL+`/ChiTietPhieuXuatKho?IdXk=${item}`, { headers: httpHeaders });
	}

	deleteOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoXuatKho>(API_ROOT_URL+`/XoaPhieuXuatKho?id=${item}`, { headers: httpHeaders });
	}

	removeOrder(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhoXuatKho>(API_ROOT_URL+`/HuyPhieuXuatKho?id=${item}`, { headers: httpHeaders });
	}

	updateStateConfirmTMP(sophieu: string): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("sophieu", sophieu).set("xacnhanvitrixk", true.toString());
		return this.http.get<any>(API_ROOT_URL+`/PhieuXuatKho_Update_StateConfirmTMP`, { headers: httpHeaders, params: httpParams });
	}

	acceptOrder(item: KhoXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhoXuatKho>(API_ROOT_URL+`/XacNhanXuatKho`, item, { headers: httpHeaders });
	}

	rejectOrder(item: KhoXuatKho): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<KhoXuatKho>(API_ROOT_URL+`/TraLaiXuatKho`, item, { headers: httpHeaders });
	}

	listSuggestion(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		
		return this.http.get<any>(API_ROOT_URL + '/DSMH_DeNghiXuatKho', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	listSuggestion__XuatBH(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		
		return this.http.get<any>(API_ROOT_URL + '/DSMH_DeNghiXuatKho_XBH', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	loadSupplierReturnType(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		
		return this.http.get<any>(API_ROOT_URL + '/request_export_supplier_return_type', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	getNumberHoanTat(FullSearch : string): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("FullSearch", FullSearch);
		return this.http.get<any>(API_ROOT_URL + '/GetNumberHoanTat', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	uploadFileImport(data): Observable<any> {
		const url = API_ROOT_URL + '/ImporttFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/DownloadFileExample`;
	}

	danhSachKhachHang_XuatKhoTheoPhieu(Id : number): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("Id", Id.toString());
		return this.http.get<any>(API_ROOT_URL + '/DanhSachKhachHang_XuatKhoTheoPhieu', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	download(IdAttachment: number): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("IdAttachment", IdAttachment.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/DownLoadFile', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	  }

	deleteDetailExport(id : number): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("id", id.toString());
		return this.http.get<any>(API_ROOT_URL + '/delete_detail_export', {
			headers: httpHeaders,
			params: httpParams
		});
	}  
	// .. Service: Xác nhận nhận đủ hàng
	confirm(data: any): Observable<any> {
		const url = API_ROOT_URL + '/confirm-received';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	// .. Service: Xóa xác nhận đủ hàng - không đồng ý
	deleteConfirmDisagree(id: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("id", id.toString());
		return this.http.get<any>(API_ROOT_URL + '/delete-confirm-received', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	// .. Xuất excel
	exportToExcel(): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams();
		return this.http.get<Blob>(API_ROOT_URL + '/export_to_excel', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	}

	// .. Xuất excel details
	exportDetailExcelFile(exportId): Observable<Blob>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = new HttpParams().set("exportId", exportId.toString());
		return this.http.get<Blob>(API_ROOT_URL + '/export_detail_excel', {
		  headers: httpHeaders,
		  params: httpParams,
		  responseType: 'blob' as 'json'
		});
	}
}
